module.exports = __webpack_public_path__ + "static/logo_dele-5f66b93a0802ed6d3ce91ecb99ce1d00.png";